import { GET_LOGIN_ADMIN } from '@/constants/login';
import { GET_OPERATION_ACCESSES_LIST } from '@/constants/operation_accesses';

export const authorityMixin = {
    data () {
        return {
            // ログインしている者の情報
            admin: {
                user_id: '',
                golf_code: '',
                user_div: ''
            },
            error: ''
        };
    },
    methods: {
        btnActive (value) {
            let ele = this.btn.find(el => el.element_id === value);
            return ele.isActive;
        },
        /** --------------------------------------------
        * 操作権限を取得
        * -------------------------------------------- */
        async getAuthority () {
            try {
                // トークンからログインユーザーのIDを取得する
                let userId = await this.$apollo.mutate({
                    mutation: GET_LOGIN_ADMIN
                }).then(res => {
                    return res.data.getLoginAdmin.user_id;
                });
                // 操作権限を取得
                this.$apollo.mutate({
                    mutation: GET_OPERATION_ACCESSES_LIST,
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        user_id: userId,
                        vue_id: this.vue_id,
                        element_id: ''
                    }
                }).then(res => {
                    let opeList = res.data.GetOperationAccessList.OperationAccessList;
                    for (let list of opeList) {
                        this.btn.forEach(el => {
                            if (list.element_id === el.element_id) {
                                if (list.element_control === 0) {
                                    el.isActive = true;
                                } else {
                                    el.isActive = false;
                                }
                            }
                        });
                    };
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
        * ログインしているユーザーを取得
        * -------------------------------------------- */
        async getLoginAdmin () {
            const result = await this.$apollo.query({
                query: GET_LOGIN_ADMIN,
                fetchPolicy: 'no-cache'
            }).then(res => {
                return res.data.getLoginAdmin.login;
            });
            return result;
        },
        /** ----------------------------------------------
        * 権限取得
        * ---------------------------------------------- */
        async getAuthorityList () {
            this.$apollo.query({
                query: GET_OPERATION_ACCESSES_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                let opeList = res.data.GetOperationAccessList.OperationAccessList;
                // this.btn = opeList.map(el => {
                //     return {
                //         'vue_id': el.vue_id,
                //         'element_id': el.element_id,
                //         'isActive': Boolean(el.element_control),
                //     }
                // });
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        }
    }
};
